"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArtFilled = function IconArtFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.5 25C31.433 25 33 23.433 33 21.5C33 19.567 31.433 18 29.5 18C27.567 18 26 19.567 26 21.5C26 23.433 27.567 25 29.5 25Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.5 38H12.5C12.3674 38 12.2402 37.9473 12.1464 37.8536C12.0527 37.7598 12 37.6326 12 37.5V12.5C12 12.3674 12.0527 12.2402 12.1464 12.1464C12.2402 12.0527 12.3674 12 12.5 12H37.5C37.6326 12 37.7598 12.0527 37.8536 12.1464C37.9473 12.2402 38 12.3674 38 12.5V37.5C38 37.6326 37.9473 37.7598 37.8536 37.8536C37.7598 37.9473 37.6326 38 37.5 38ZM8 8.5V41.5C8 41.6326 8.05268 41.7598 8.14645 41.8536C8.24021 41.9473 8.36739 42 8.5 42H41.5C41.6326 42 41.7598 41.9473 41.8536 41.8536C41.9473 41.7598 42 41.6326 42 41.5V8.5C42 8.36739 41.9473 8.24021 41.8536 8.14645C41.7598 8.05268 41.6326 8 41.5 8H8.5C8.36739 8 8.24021 8.05268 8.14645 8.14645C8.05268 8.24021 8 8.36739 8 8.5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.59 28.43C25.83 27.93 24.54 26.43 22.96 25.5C20.72 24.18 18.11 24.05 15.51 24.02C15.4435 24.0187 15.3774 24.0306 15.3156 24.0552C15.2538 24.0797 15.1975 24.1163 15.15 24.1629C15.1025 24.2094 15.0647 24.265 15.039 24.3263C15.0132 24.3876 15 24.4535 15 24.52V34.52C15 34.6526 15.0527 34.7798 15.1464 34.8736C15.2402 34.9673 15.3674 35.02 15.5 35.02H34.5C34.6326 35.02 34.7598 34.9673 34.8536 34.8736C34.9473 34.7798 35 34.6526 35 34.52V28.38C35 28.2474 34.9473 28.1202 34.8536 28.0264C34.7598 27.9327 34.6326 27.88 34.5 27.88C32.19 28 29.81 29.06 27.59 28.43Z",
    fill: color
  }));
};

IconArtFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconArtFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconArtFilled;
exports.default = _default;